#include ../includes/simplexNoise4d.glsl

uniform float Influence;
uniform float Strength;
uniform float Frequency;
uniform float uTime;
uniform float uDeltaTime;
uniform sampler2D uBase;

// Simplex flow (by Bruno Simon)
void main() {
    float time = uTime * 0.2;
    vec2 uv = gl_FragCoord.xy / resolution.xy;
    vec4 particle = texture(uParticles, uv);
    vec4 base = texture(uBase, uv);

    if(particle.a >= 1.0) {
        particle.a = mod(particle.a, 1.0);
        particle.xyz = base.xyz;
    } else {
        float strength = simplexNoise4d(vec4(base.xyz * 0.2, time + 1.0));
        float influence = (Influence - 0.5) * (-2.0);
        strength = smoothstep(influence, 1.0, strength);

        vec3 flowField = vec3(
            simplexNoise4d(vec4(particle.xyz * Frequency + 0.0, time)), 
            simplexNoise4d(vec4(particle.xyz * Frequency + 1.0, time)), 
            simplexNoise4d(vec4(particle.xyz * Frequency + 2.0, time))
        );
        flowField = normalize(flowField);
        particle.xyz += flowField * uDeltaTime * strength * Strength;

        particle.a += uDeltaTime * 0.25;
    }
    gl_FragColor = particle;
}